module.exports = __webpack_public_path__ + "media/metronic/_theme/media/users/user1-0d0d1a790bf34e8e91c35384267d01bb.jpg";